import { Component } from '@angular/core';
import { Booking, BookingService } from '../../services/Booking/booking.service';
import { MatIconModule } from "@angular/material/icon";
import { CommonModule } from '@angular/common';

import { ReactiveFormsModule, FormGroup, FormControl, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { Address, AuthService, Theater } from '../../services/Auth/auth.service';
import { Timestamp } from '@angular/fire/firestore';
import { PhoneMaskDirective } from '../../directives/phone-mask.directive';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RouterLink, RouterModule } from "@angular/router";
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
    selector: 'app-booking-popup',
    imports: [
        CommonModule,
        MatIconModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatInputModule,
        MatSelectModule,
        PhoneMaskDirective,
        RouterLink,
        RouterModule
    ],
    templateUrl: './booking-popup.component.html',
    styleUrl: './booking-popup.component.scss'
})
export class BookingPopupComponent {
    bookingForm = new FormGroup({
        theater: new FormControl('', [Validators.required]),
        theaterList: new FormControl([], []),
        enableMultipleTheaters: new FormControl(false),
        city: new FormControl('', [Validators.required]),
        phone: new FormControl('', [Validators.pattern(/^\(\d{3}\) \d{3}-\d{4}$/)]),
        adress: new FormControl(''),
        zip: new FormControl(''),
        state: new FormControl('', [Validators.required]),
        format: new FormControl('', [Validators.required]),
        startDate: new FormControl(null, [Validators.required]),
        endDate: new FormControl(null, [Validators.required]),
        notes: new FormControl(''),
        admission: new FormControl(false),
    });

    terms: string = '---'
    now: Date = new Date()
    endDateEnabled: boolean = false

    theaters: string[] = [
        'Westwood Cineplex',
        'Starlight Theater',
        'Downtown Cinema'
    ];

    cities: string[] = [
        'Los Angeles',
        'San Francisco',
        'New York'
    ];

    formats: string[] = [
        'Rights only —Self Supplied',
        'DCP',
        '35mm'
    ];

    admissions = [
        { code: true, name: 'Yes' },
        { code: false, name: 'No' },
    ]

    states = [
        { code: 'AL', name: 'Alabama' },
        { code: 'AK', name: 'Alaska' },
        { code: 'AZ', name: 'Arizona' },
        { code: 'AR', name: 'Arkansas' },
        { code: 'CA', name: 'California' },
        { code: 'CO', name: 'Colorado' },
        { code: 'CT', name: 'Connecticut' },
        { code: 'DE', name: 'Delaware' },
        { code: 'DC', name: 'District of Columbia' },
        { code: 'FL', name: 'Florida' },
        { code: 'GA', name: 'Georgia' },
        { code: 'HI', name: 'Hawaii' },
        { code: 'ID', name: 'Idaho' },
        { code: 'IL', name: 'Illinois' },
        { code: 'IN', name: 'Indiana' },
        { code: 'IA', name: 'Iowa' },
        { code: 'KS', name: 'Kansas' },
        { code: 'KY', name: 'Kentucky' },
        { code: 'LA', name: 'Louisiana' },
        { code: 'ME', name: 'Maine' },
        { code: 'MD', name: 'Maryland' },
        { code: 'MA', name: 'Massachusetts' },
        { code: 'MI', name: 'Michigan' },
        { code: 'MN', name: 'Minnesota' },
        { code: 'MS', name: 'Mississippi' },
        { code: 'MO', name: 'Missouri' },
        { code: 'MT', name: 'Montana' },
        { code: 'NE', name: 'Nebraska' },
        { code: 'NV', name: 'Nevada' },
        { code: 'NH', name: 'New Hampshire' },
        { code: 'NJ', name: 'New Jersey' },
        { code: 'NM', name: 'New Mexico' },
        { code: 'NY', name: 'New York' },
        { code: 'NC', name: 'North Carolina' },
        { code: 'ND', name: 'North Dakota' },
        { code: 'OH', name: 'Ohio' },
        { code: 'OK', name: 'Oklahoma' },
        { code: 'OR', name: 'Oregon' },
        { code: 'PA', name: 'Pennsylvania' },
        { code: 'PR', name: 'Puerto Rico' },
        { code: 'RI', name: 'Rhode Island' },
        { code: 'SC', name: 'South Carolina' },
        { code: 'SD', name: 'South Dakota' },
        { code: 'TN', name: 'Tennessee' },
        { code: 'TX', name: 'Texas' },
        { code: 'UT', name: 'Utah' },
        { code: 'VT', name: 'Vermont' },
        { code: 'VA', name: 'Virginia' },
        { code: 'WA', name: 'Washington' },
        { code: 'WV', name: 'West Virginia' },
        { code: 'WI', name: 'Wisconsin' },
        { code: 'WY', name: 'Wyoming' }
    ];

    specialTerms: string[] = [
        'MT', 'PA', 'PR', 'ID', 'KY', 'OH', 'UT'
    ]

    isNewTheater: boolean = false
    enableMultipleTheaters: boolean = false
    multiTheatersInvalid: boolean = false

    constructor(
        public bookingService: BookingService,
        public authService: AuthService,
        private snackBar: MatSnackBar,
    ) {
        this.authService.profileLoaded$.subscribe((isLoaded) => {
            if (isLoaded && this.authService.profile) {
                this.theaters = this.authService.profile.theaters.map((theater) => theater.name)
            }
        })
    }

    ngOnInit() {
        // Disable background scrolling when popup is open
        this.bookingService.isBookingOpen$.subscribe(isOpen => {
            if (isOpen) {
                this.bookingForm.reset()
                if (this.bookingForm.value) {
                    this.enableMultipleTheaters = this.bookingForm.value.enableMultipleTheaters == true
                }

                document.body.style.overflow = 'hidden';
                if (this.bookingService.movie?.FormatList) {
                    this.formats = this.bookingService.movie?.FormatList
                }
            }
            else {
                document.body.style.overflow = '';
            }
        })


    }

    ngOnDestroy() {
        // Restore background scrolling when popup is closed
        document.body.style.overflow = '';
    }

    close() {
        this.bookingService.close()
    }

    getImage(): string {
        if (this.bookingService.movie && this.bookingService.movie?.pageBgList) {
            if (this.bookingService.movie?.pageBgList?.length > 0) {
                return this.bookingService.movie?.pageBgList[0]
            }
        }
        return this.bookingService.movie?.pageBg ? this.bookingService.movie?.pageBg : ''
    }

    onMultipleTheaterSelected(event: any) {
        this.multiTheatersInvalid = true

        if (this.bookingForm.get('theaterList') && this.bookingForm.get('theaterList')?.value) {
            // this.bookingForm.get('theater').value = this.bookingForm.get('theaterList')[0].value 
            if (this.bookingForm && this.bookingForm.get('theaterList') && this.bookingForm.get('theaterList')) {


                let theaterList = this.bookingForm.get('theaterList')
                if (theaterList && theaterList.value && theaterList.value.length) {
                    this.multiTheatersInvalid = false
                    this.bookingForm.patchValue({ theater: theaterList.value[0] })
                    var theaterName = theaterList.value[0]
                    var index = -1

                    if (this.authService.profile) {

                        this.authService.profile.theaters.forEach((theater, i) => {
                            if (theater.name == theaterName) {
                                index = i
                            }
                        });

                        let theater = this.authService.profile.theaters[index]

                        this.bookingForm.patchValue({
                            city: theater.city,
                            state: theater.state,
                            format: theater.preferredFormat,
                            admission: theater.admissionCharges
                        })

                        let city = this.bookingForm.get('city')?.value
                        if (city) {
                            city = this.authService.profile.theaters[index].city
                        }

                    }
                    else {
                        this.bookingForm.patchValue({ theater: '' })
                    }



                    // if (this.bookingForm.get('theaterList') ? [0]) {

                    //     this.bookingForm.patchValue({
                    //     })
                    // }

                }
            }
        }
    }

    onTheaterSelected() {
        let theaterName = this.bookingForm.get('theater')?.value
        let index = 0
        if (theaterName == '--NEW--') {
            this.isNewTheater = true

        }
        else {
            this.isNewTheater = false
            if (this.authService.profile) {

                this.authService.profile.theaters.forEach((theater, i) => {
                    if (theater.name == theaterName) {
                        index = i
                    }
                });

                let theater = this.authService.profile.theaters[index]

                this.bookingForm.patchValue({
                    city: theater.city,
                    state: theater.state,
                    format: theater.preferredFormat,
                    admission: theater.admissionCharges
                })

                let city = this.bookingForm.get('city')?.value
                if (city) {
                    city = this.authService.profile.theaters[index].city
                }
            }
        }


        this.updateTerms()
    }

    onCitySelected() {
        this.updateTerms()
    }

    onStateSelected() {
        this.updateTerms()
    }

    onFormatSelected() {
        this.updateTerms()
    }

    onAdmissionSelected() {
        this.updateTerms()
    }

    onStartDateChange() {
        // Reset end date if it's before the new start date
        const startDate = this.bookingForm.get('startDate')?.value;
        const endDate = this.bookingForm.get('endDate')?.value;

        if (startDate && endDate && endDate < startDate) {
            this.bookingForm.get('endDate')?.setValue(null);
        }

        this.endDateEnabled = true
        this.updateTerms()
    }

    updateTerms() {
        let booking: Booking = new Booking(this.bookingForm.value)
        this.terms = "---"
        if (booking.state == undefined) return

        if (this.specialTerms.indexOf(booking.state) != -1) {
            // special case
            if (booking.admission) {
                this.terms = "TBD"
            }
            else {
                if (booking.format.includes('Rights ')) {
                    this.terms = "$100 flat per screening"
                }
                else {
                    if (booking.format == '35mm Print' || booking.format == '70mm Print') {
                        this.terms = "$250 flat per screening"
                    }
                    else {
                        this.terms = "$150 flat per screening"
                    }
                }
            }
        }
        else {
            // normal case
            if (!booking.admission) {
                if (booking.format.includes('Rights ')) {
                    this.terms = "$100 flat per screening"
                }
                else {
                    if (booking.format == '35mm Print' || booking.format == '70mm Print') {
                        this.terms = "$250 flat per screening"
                    }
                    else {
                        this.terms = "$150 flat per screening"
                    }
                }
            }
            else {
                if (booking.format.includes('Rights ')) {
                    this.terms = "$100 vs 35%"
                }
                else {
                    if (booking.format == '35mm Print' || booking.format == '70mm Print') {
                        this.terms = "$250 vs 35%"
                    }
                    else {
                        this.terms = "$150 vs 35%"
                    }
                }
            }
        }
    }

    reset() {

    }

    onSubmit() {
        this.updateTerms()

        if (this.isNewTheater) {
            let theater = new Theater(this.bookingForm.value)
            theater.name = this.bookingForm.value.theater ? this.bookingForm.value.theater : ''
            theater.admissionCharges = this.bookingForm.value.admission == true
            theater.preferredFormat = this.bookingForm.value.format ? this.bookingForm.value.format : 'Rights only —Self Supplied'
            this.authService.profile?.theaters.push(theater)
            this.authService.saveProfile()
        }

        console.log(this.bookingForm.value);
        

        let booking: Booking = new Booking(this.bookingForm.value)
        booking.created = Timestamp.fromDate(new Date())
        booking.terms = this.terms
        booking.userName = this.authService.profile?.firstName + " " + this.authService.profile?.lastName
        let startDate = this.bookingForm.value.startDate
        if (startDate) {
            (startDate as Date).setHours(12)
            booking.startDate = Timestamp.fromDate(startDate)
        }

        let availableFormats = this.bookingService.movie?.FormatList
        if( !availableFormats?.includes(booking.format) ) {
            this.bookingForm.reset()
            this.snackBar.open('Internal server error, please fill out the form again', '+', { duration: 3000 });
            return    
        }

        this.snackBar.open('Booking Request Submitted', '+', { duration: 3000 });

        let endDate = this.bookingForm.value.endDate
        if (endDate) {
            (endDate as Date).setHours(12)
            booking.endDate = Timestamp.fromDate(endDate)
        }


        if (this.enableMultipleTheaters) {
            var theaterListObj = this.bookingForm.value.theaterList?.map((item: string) => {
                var newTheater = new Theater({})
                if (this.authService.profile) {
                    this.authService.profile.theaters.forEach((theater, i) => {
                        if (theater.name == item) {
                            newTheater = new Theater(theater)
                        }
                    });
                }
                return newTheater
            })
            if (theaterListObj) {
                booking.theaterListObj = theaterListObj
            }

        }

        this.bookingService.onSubmitBooking(booking, this.authService.uid).then((docId) => {
            console.log(docId);
            this.close()
            if (docId) {
                this.authService.profile?.bookingList.push(docId)
                this.authService.saveProfile()
            }
        })

        this.bookingForm.reset()
    }

    isDisabled() {

        return false;
    }

    multipleTheatersChnage(val: boolean) {
        // console.log(this.enableMultipleTheaters)
        this.enableMultipleTheaters = val
        if (val) {
            this.multiTheatersInvalid = true
        }
        else {
            this.multiTheatersInvalid = false
        }
    }
}
